/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description navbar reducer
 */

import { payloadReducer } from '@zcode/reducers'
import type { Navbar } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction } from 'redux-actions'

import { NAVBAR_MOBILE_LIST, NAVBAR_STICKY_DEFAULT } from '../../../constants/navbar'
import type * as actions from '../actions'
import { SET_MOBILE_VIEW_TYPE, SET_NAVBAR_STICKY } from '../constants/index'

type Actions = ExtractActions<Values<typeof actions>>

const navbarReducer = combineReducers<Navbar, Actions>({
  mobileViewType: handleAction<Navbar['mobileViewType'], Actions, typeof SET_MOBILE_VIEW_TYPE>(
    SET_MOBILE_VIEW_TYPE,
    payloadReducer,
    NAVBAR_MOBILE_LIST
  ),
  isNavbarSticky: handleAction<Navbar['isNavbarSticky'], Actions, typeof SET_NAVBAR_STICKY>(
    SET_NAVBAR_STICKY,
    payloadReducer,
    NAVBAR_STICKY_DEFAULT
  ),
})

export default navbarReducer
